// src/contexts/FeatureFlagsContext.jsx
import React, { createContext, useContext, useMemo } from "react";
import { Capacitor } from "@capacitor/core";

const FeatureFlagsContext = createContext(null);

export const FeatureFlagsProvider = ({ children }) => {
  const platform = Capacitor.getPlatform(); 
  const isNative = Capacitor.isNativePlatform();
  const isPWAStandalone =
    typeof window !== "undefined" &&
    ("standalone" in window.navigator
      ? window.navigator.standalone
      : window.matchMedia?.("(display-mode: standalone)").matches);

  // pega dos envs (CRA: REACT_APP_*)
  const enableStripe = process.env.REACT_APP_ENABLE_STRIPE === "1";
  const enableStoreBilling = process.env.REACT_APP_ENABLE_STORES === "1";

  const flags = useMemo(
    () => ({
      isNative,
      platform,
      isPWAStandalone,
      enableStripe,
      enableStoreBilling,
    }),
    [isNative, platform, isPWAStandalone, enableStripe, enableStoreBilling]
  );

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const ctx = useContext(FeatureFlagsContext);
  if (!ctx) throw new Error("useFeatureFlags deve ser usado dentro de FeatureFlagsProvider");
  return ctx;
};
